import PIXI from 'pixi.js/src';

const renderHelper = {
  /**
   * Sets up the PIXI.js scene
   * @param {HTMLElement} container - The container to render the game into
   * @returns {undefined} undefined
   */
  init(container) {
    this.stage = new PIXI.Container(0x66FF99);
    this.renderer = PIXI.autoDetectRenderer(
      window.innerWidth, window.innerHeight,
      { resolution: 2 }
    );
    this.renderer.view.style.position = 'absolute';
    this.renderer.view.style.display = 'block';
    this.renderer.autoResize = true;
    this.renderer.resize(window.innerWidth, window.innerHeight);

    container.appendChild(this.renderer.view);

    window.addEventListener('resize', this.resize.bind(this));
    window.requestAnimationFrame(this.animate.bind(this));
  },


  /**
   * Renders the PIXI.js scene
   * @returns {undefined} undefined
   */
  animate() {
    window.requestAnimationFrame(this.animate.bind(this));
    this.renderer.render(this.stage);
  },


  /**
   * Called when the window is resized
   * @returns {undefined} undefined
   */
  resize() {
    this.renderer.resize(window.innerWidth, window.innerHeight);
  },
};

export default renderHelper;



/** WEBPACK FOOTER **
 ** ./assets/js/src/helpers/render.js
 **/